import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Send an email to `}<a parentName="p" {...{
        "href": "mailto:ashwanicena5@gmail.com"
      }}>{`ashwanicena5@gmail.com`}</a>{` or find me on other platforms: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/ashwanisng/"
      }}>{`LinkedIn`}</a>{` & `}<a parentName="p" {...{
        "href": "https://github.com/ashwanisng"
      }}>{`GitHub`}</a></p>
    <p>{`Download a copy of my `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1VVS0ak7A-NsznYZMVHYjnHre896gz7b0/view?usp=sharing"
      }}>{`Resume`}</a>{` here.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      